// import '../types'
// a sequence of invisible UTF chars is used to mark the string as translateable
// (zero-width spacings)
// const I18nStringIdentifier = "\uFEFF\u200B\uFEFF";
const I18nStringIdentifier = "i18n::";
export function stripI18nIdentifier(text) {
  return text.startsWith(I18nStringIdentifier) ? text.substring(6) : text;
}
// as primitives cannot store extra data, we use a map to store which key belongs to which defaultText value.
const keyMap = new Map();
export function getOptionalI18nKey(str) {
  if (typeof str !== 'string') return null;
  if (!str.startsWith(I18nStringIdentifier)) {
    return null;
  } else {
    const extracted = stripI18nIdentifier(str);
    const paramsIndex = extracted.indexOf(' {');
    if (paramsIndex > -1) {
      const key = extracted.substring(0, paramsIndex);
      const paramsString = extracted.substring(paramsIndex + 1);
      let params = {};
      if (paramsString.length > 1) {
        params = JSON.parse(paramsString);
      }
      return {
        key,
        params
      };
    } else {
      return {
        key: extracted,
        params: {}
      };
    }
    // if(keyMap.has(str)) {
    // 	return keyMap.get(str)
    // } else {
    // 	return stripI18nIdentifier(str)
    // }
  }
}
/**
 * the globally available markI18n function allows to "mark" a bit of a text to be translateable.
 * actively executed translation requires access to injected services, may require async logic etc.
 * as this is not always simple to achieve, think about data within decorators and such.
 * The markI18n function will add some invisible Unicode chars so that handlers will later be able to identify it as translateable.
 *
 * notes:
 * - invisibile unicode chars could be used. e.g. U+200B ZERO WIDTH SPACE
 * 	- when using primitive with extra chars, it is not possible to store additional ID / settings data.
 * 	- a registration map for extra data could be written. But it would be keyed with primitives, so duplicate values may conflict.
 */
export const markI18n = (key, params = {}) => {
  if (key.indexOf(' ') > -1) throw new Error('marI18n key must not contain spaces!');
  const hasParams = Object.keys(params).length > 0;
  let out = I18nStringIdentifier + key;
  if (hasParams) out += ' ' + JSON.stringify(params);
  // if(!defaultText) defaultText = key;
  // const enhancedDefault = defaultText + I18nStringIdentifier
  // keyMap.set(enhancedDefault,key);
  return out;
};
globalThis.markI18n = markI18n;